class PageNavi {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // 前のページリンクの処理
    var prevLink = document.querySelector('.previouspostslink');
    if (prevLink) {
        var prevSpan = document.createElement('span');
        prevLink.appendChild(prevSpan);
    }

    // 次のページリンクの処理
    var nextLink = document.querySelector('.nextpostslink');
    if (nextLink) {
        var nextSpan = document.createElement('span');
        nextLink.appendChild(nextSpan);
    }
  }
}